import { Container, GridSculpture, Hero } from '@dylanlewis/shared';
import React from 'react';
import { NavLink } from 'react-router-dom';

export class PageSculpture extends React.Component {
  render() {
    const { page, heroDetails } = this.props;

    return (
      <Container>
        <Hero
          noCrop={heroDetails.noCrop}
          renderVisual={heroDetails.visual}
          subtitle={heroDetails.subtitle}
          title={heroDetails.title}
        />

        {page.acf.grid.items && (
          <GridSculpture
            items={page.acf.grid.items}
            parent={'studio'}
            linkAs={NavLink}
          />
        )}
      </Container>
    );
  }
}
